// extracted by mini-css-extract-plugin
module.exports = {"SectionCarousel":"SectionCarousel_SectionCarousel__ZLrFP"};